import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-pd-surface">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-xs uppercase tracking-[0.25em] font-medium text-pd-sage">What We Do</span>
          <h2 className="mt-4 font-display text-4xl lg:text-5xl font-medium leading-tight text-pd-forest">
            Complete dental care, <span className="italic text-pd-accent">all under one roof.</span>
          </h2>
          <p className="mt-5 text-lg text-pd-body">
            From routine check-ups to full smile makeovers — our experienced team covers
            every treatment you and your family need.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Activity;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                className="group bg-pd-bg rounded-3xl p-7 border border-pd-forest/5 shadow-sm hover:shadow-xl hover:shadow-pd-forest/10 hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span className="w-14 h-14 rounded-2xl bg-pd-surface group-hover:bg-pd-terra transition-colors duration-300 flex items-center justify-center">
                    <Icon size={26} className="text-pd-accent group-hover:text-white transition-colors duration-300" />
                  </span>
                  <ArrowUpRight size={20} className="text-pd-muted opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all duration-300" />
                </div>
                <h3 className="mt-6 font-display text-2xl text-pd-forest">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-pd-body">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
